<template>
  <div class="genomics-index">
    <div class="genomice-header">
      <div class="genomice-h-info">
        <span class="genomice-h-name">{{ gACCData.name }}</span>
        <span class="genomice-h-isoform">
          <a-dropdown overlayClassName="hospital-dropdown-overlay" class="hospital-dropdown-link"
            @visibleChange="visibleChange1">
            <a class="ant-dropdown-link" :class="isVisibleDropdown1 ? 'hospital-dropdown-linkOn' : ''">
              {{ searchLableIsoform }}
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay" style="height: 120px; overflow: hidden; overflow-y: scroll;" @click="checkIsoform">
              <a-menu-item v-for="item, index in isoformMapItem" :key="index">
                <a href="javascript:;">{{ item.isoform }}</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
        <!-- {{ gACCData.isoform }} -->
        <span class="genomice-hg-num">{{ gACCData.geneChain }}</span>
      </div>
      <div class="genomice-h-info">
        {{ gACCData.description || '--' }}
        <span class="genomice-h-name genomice-text-underline" @click="goToEnsemblPage()">Ensembl</span>
        <span class="genomice-h-name genomice-text-underline" @click="goToGenePage()">NCBI</span>
        <div class="genomice-h-chr-num">
          {{ gACCData.geneChain }}:{{ gACCData.start }}-{{ gACCData.end }}
        </div>
      </div>
    </div>
    <a-row class="amino-box">
      <a-col :xs="19" :sm="19" :md="19" :lg="19" :xl="19" :xxl="18">
        <div class="genomice-svg-main">
          <div class="genomice-search-main">
            <genomics-search-tools v-if="apiOption1.transcriptId" :initType="'default'" :key="initTypeDefault"
              :apiOption="apiOption1" :checkeds="{}" :searchQueryData="searchQueryData"
              @updateSearchQueryData="updateSearchQueryData(arguments)">
            </genomics-search-tools>
          </div>
          <div class="genomice-content-conter">
            <div class="genomice-isoform-info">
              <div class="genomice-isoform-genename" @click="discClickFun({ nodeData: { tabIndex: 3, tabType: 'all' } })">
                {{ gACCData.name }}</div>
              <div class="genomice-isoform-name">
                <a-dropdown overlayClassName="hospital-dropdown-overlay" class="hospital-dropdown-link"
                  @visibleChange="visibleChange2">
                  <a class="ant-dropdown-link" :class="isVisibleDropdown2 ? 'hospital-dropdown-linkOn' : ''">
                    {{ searchLableIsoform }}
                    <a-icon type="down" />
                  </a>
                  <a-menu slot="overlay" style="height: 120px; overflow: hidden; overflow-y: scroll;"
                    @click="checkIsoform">
                    <a-menu-item v-for="item, index in isoformMapItem" :key="index">
                      <a href="javascript:;">{{ item.isoform }}</a>
                    </a-menu-item>
                  </a-menu>
                </a-dropdown>
                <!-- {{ gACCData.isoform }} -->
              </div>
            </div>
            <div class="genomice-slider-middle">
              <a-slider v-model:value="sliderVal" @change="sliderChange" :tooltip-visible="false" :included="false" />
            </div>
            <div class="genomice-check-in">
              <!-- <span class="f-check-btn f-check-mbtn" @click="checkIsoform()">iso</span> -->
              <span class="f-check-btn f-check-mbtn" :class="multiple == 20 ? 'on' : ''"
                @click="checkMultipleMin('20')">Min</span>
              <span class="f-check-btn f-check-mbtn" :class="multiple == 50 ? 'on' : ''"
                @click="checkMultipleMax('50')">Max</span>
              <span class="f-check-btn" :class="multiple == 10 ? 'on' : ''" @click="checkIn">＋</span>
              <span class="f-check-btn" :class="multiple == -10 ? 'on' : ''" @click="checkOut">－</span>
            </div>
            <svg id="genomice-svg-content" class="genomice-svg-content" width="100%" style="min-height: 360px"></svg>
          </div>
          <template v-if="(flag == 1 || flag == 2) && newResQueryDataAll" v-for="(item, val) of newResQueryDataAll">
            <div class="genomice-svg-down-main" :id="item.id">
              <span class="g-s-close" @click="removeItem(item.id, val)">×</span>
              <genomics-b-b :key="val + '-' + item.times" :newResQueryDataAll="item" :keyVal="val"
                :codingSite="gACCData.codingSite" @updateSearchQueryData="updateSearchQueryData(arguments)"
                @discClickBBDataFun="discClickBBDataFun(arguments)">
              </genomics-b-b>
            </div>
          </template>
        </div>
      </a-col>
      <a-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5" :xxl="6">
        <div class="amino-clb">
          <h3 class="amino-clb-tit">
            类型：
            <a-switch size="small" class="fr" checked-children="off" v-model="lollipopChecked" un-checked-children="on"
              @change="(value) => changeLollipopDisplay(value)" default-checked />
          </h3>
          <div class="amino-clb-box">
            <template v-for="item in lollipopDB.classes">
              <div class="amino-clb-item" @click="changeLollipopDislayClasses(item.name)">
                <div class="amino-clb-check">
                  <em v-if="displayClassesCheck && displayClasses.hasOwnProperty(item.name)" class="a-clb-dot"
                    :style="{ 'background': '#fff', 'border-color': item.color }"></em>
                  <em v-else class="a-clb-dot" :style="{ 'background': item.color, 'border-color': item.color }"></em>
                  {{ item.name }}
                  <span class="a-clb-num">（{{ item.number }}）</span>
                </div>
              </div>
            </template>
          </div>
          <h3 class="amino-clb-tit">蛋白质结构域：</h3>
          <div class="amino-clb-box item-meta">
            <a-list item-layout="horizontal" :data-source.sync="gACCData.pdomainFilter">
              <a-list-item slot="renderItem" slot-scope="item">
                <a-list-item-meta :description="item.description">
                  <a slot="title">{{ item.name }}</a>
                  <a slot="title" v-if="item.cdd && item.cdd.indexOf('t') != 0" class="amino-clb-a"
                    :href="'https://www.ncbi.nlm.nih.gov/Structure/cdd/cddsrv.cgi?uid=' + item.cdd"
                    target="_blank">CDD</a>
                  <a slot="title" v-if="item.pfam" class="amino-clb-a" :href="'http://pfam.xfam.org/family/' + item.pfam"
                    target="_blank">Pfam</a>
                  <a slot="title" v-if="item.smart" class="amino-clb-a"
                    :href="'https://smart.embl.de/smart/do_annotation.pl?BLAST=DUMMY&DOMAIN=' + item.smart"
                    target="_blank">Smart</a>
                  <a slot="title" v-if="item.tigrfam" class="amino-clb-a"
                    :href="'http://www.ebi.ac.uk/interpro/entry/tigrfams/' + item.tigrfam" target="_blank">TIGRfam</a>
                  <a-avatar slot="avatar" :style="{ 'background-color': item.color }" />
                </a-list-item-meta>
                <a slot="actions">
                  <a-switch size="small" class="fr" checked-children="off" un-checked-children="on"
                    @change="(value) => changePdomain(value, item)" default-checked />
                </a>
              </a-list-item>
            </a-list>
          </div>
          <div class="amino-clb-add" @click="clickProteinAdd">+ 新建蛋白质结构域</div>
        </div>
      </a-col>
    </a-row>
    <div class="genomics-move-menu-tip">
      <div class="genomics-move-menu-content">
        <div><span>exon:</span>{{ exonTipInfo.Exon }}</div>
        <div><span>AA:</span>{{ exonTipInfo.AA }}</div>
        <div><span>RNA:</span>{{ exonTipInfo.RNA }} bp</div>
        <div><span>{{ gACCData.geneChain }}:</span>{{ exonTipInfo.Pos }}</div>
        <div v-if="movePdomainData.length > 0">
          <div class="genomics-pdomain-row" v-for="(item, index) in reverseMovePdomainData">
            <em class="genomics-pdomain-avatar" :style="{ 'backgroundColor': item.color }"></em>{{ item.name }} <i
              class="genomice-move-content-i">{{
                item.description.substring(0, 15)
              }}...</i>
          </div>
        </div>

      </div>
    </div>
    <div class="genomics-move-disc-tip">
      <div class="genomice-move-disc-content">
        <div><span>R162K 21</span></div>
        <div><span>ETV6 21</span></div>
      </div>
      <div class="bubble-t-arrow">
        <div class="bubble-t-arrow-inner"></div>
      </div>
    </div>
    <drag-modal :visible="isVisible" :width="'75%'" :footer="false" :mask="false">
      <genomics-pos-info v-if="isVisible" :queryData="posDiscData" :geneName="apiOption.name"
        :partName="apiOption1.transcriptId" @cancel="() => isVisible = false"></genomics-pos-info>
    </drag-modal>
    <drag-modal :visible="isVisibleProtein" :width="'500px'" @cancel="() => isVisibleProtein = false" @ok="proteinAdd">
      <genomics-protein-add v-if="isVisibleProtein" ref="refGenomicsProteinAdd" :geneName="apiOption.name"
        :partName="apiOption1.transcriptId" @cancel="() => isVisibleProtein = false"
        @proteinUpdate="proteinUpdate(arguments)"></genomics-protein-add>
    </drag-modal>
    <!-- <page-model @close="closeModel" :visible="isVisible">
        <genomics-pos-info v-if="isVisible" :queryData="posDiscData" :geneName="apiOption.name"></genomics-pos-info>
      </page-model> -->
  </div>
</template>
<!-- CDD--Pfam---Smart--TIGRfam -->
<!-- https://www.ncbi.nlm.nih.gov/Structure/cdd/cddsrv.cgi?uid=176085   CDD
http://pfam.xfam.org/family/PF13893   Pfam
https://smart.embl.de/smart/do_annotation.pl?BLAST=DUMMY&DOMAIN=SM00349   Smart
http://www.ebi.ac.uk/interpro/entry/tigrfams/TIGR00892   TIGRfam -->
<script>
import NProgress from 'nprogress';
import * as d3 from "d3";
import render from "d3-render";
import genomicsD3Utils from "../../common/genomics-d3Utils";
import genomicsACCUtils from "../../common/genomics-AACUtils";
import GenomicsBB from '@/components/molecular/genomicsBBData';
import GenomicsSearchTools from '@/components/molecular/genomicsSearchTools.vue';
import GenomicsPosInfo from './genomics-pos-info.vue';
import GenomicsProteinAdd from './genomics-protein-add.vue';
import DragModal from '../../components/common/dragModal/dragModal.vue';

export default {
  components: { GenomicsSearchTools, GenomicsBB, GenomicsPosInfo, GenomicsProteinAdd, DragModal },
  data() {
    return {
      sliderVal: 50,
      lollipopChecked: true,
      isoformIndex: 0,
      hiddenPdomain: {},
      dataALL: [],
      accSeqData: "",
      gACCData: [],
      movePdomainData: [],
      exonTipInfo: {},
      lollipopDB: {},
      bbdata: {},
      size: 'small',
      contentWidth: 890,
      defaultContentWidth: 890,
      middleTranslate: { middleX: 0, middleY: 306 },
      scribingStyle: { startLeft: 0 },
      sliderVisible: 'none',
      sliderOffsetX: 0,
      checkInFlag: 1,
      multiple: 0,
      apiOption: { name: "ETV6", version: "hg19" },
      apiOption1: { geneName: "ETV6", transcriptId: "" },
      displayClasses: {},
      displayClassesCheck: false,
      flag: 0,
      isVisible: false,
      isVisibleProtein: false,
      searchQueryData: {
        dataH: [],
        dataC: [],
        dataM: [],
        dataB: []
      },
      newResQueryDataAll: {},
      posDiscData: {},
      initTypeDefault: 'default_' + new Date().getTime(),
      searchLableIsoform: '',
      isoformMapItem: [],
      isVisibleDropdown1: false,
      isVisibleDropdown2: false,
    };
  },
  watch: {
    newResQueryDataAll(newVal, oldVal) {
      this.newResQueryDataAll = Object.assign(newVal, oldVal);
      this.flag = 1;
    },
    $route() {
      //跳转到该页面后需要进行的操作
      this.$router.go()
    }

  },
  created() {

  },
  computed: {
    reverseMovePdomainData() {
      return this.movePdomainData.reverse();
    }
  },
  mounted() {
    this.apiOption.name = this.$route.query.name;
    this.apiOption1.geneName = this.$route.query.name;
    this.getInitBaseData();
  },
  methods: {
    /**
     * 获取snp&fusion (圆盘颜色)
     * @param {*} name 
     */
    getDiscColor(name) {
      return genomicsACCUtils.discColorMap[name];
    },
    /**
     * 更新查询参数
     * @param {*} param 
     */
    updateSearchQueryData(param) {
      this.flag = param[0];
      this.newResQueryDataAll = Object.assign({}, this.newResQueryDataAll, param[1]);
    },
    /**
     * 清除查询结果块
     * @param {*} id 
     * @param {*} keys 
     */
    removeItem(id, keys) {
      NProgress.start();
      d3.select('#' + id).remove();
      delete this.newResQueryDataAll[keys];
      NProgress.done();
    },
    visibleChange1(visible) {
      this.isVisibleDropdown1 = visible;
    },
    visibleChange2(visible) {
      this.isVisibleDropdown2 = visible;
    },
    /**
     * 切换转录本
     */
    checkIsoform({ key }) {
      NProgress.start();
      let $this = this;
      // $this.contentWidth = $this.defaultContentWidth;
      setTimeout(() => {
        d3.select("#genomice-svg-content").selectAll('*').remove();
        $this.isoformIndex = key;
        $this.initTypeDefault = 'default_' + new Date().getTime();
        $this.contentWidth = $this.defaultContentWidth;
        $this.sliderVal = 50;
        $this.sliderOffset($this.sliderVal);
        let sum = ($this.contentWidth - $this.defaultContentWidth) / 2;
        if (sum == 0) {
          $this.sliderVisible = 'none';
        }
        $this.checkInFlag = 1;
        Object.keys($this.newResQueryDataAll).forEach((key, index) => {
          d3.select('#' + $this.newResQueryDataAll[key].id).remove();
        });

        $this.tackleBaseData($this.dataALL, $this.isoformIndex, () => {
          $this.getInitBBData();
          $this.newResQueryDataAll = {};
          $this.middleTranslate.middleX = '-' + sum;
          NProgress.done();
        });
        $this.isVisibleDropdown1 = false;
        $this.isVisibleDropdown2 = false;
      }, 100);
    },
    /**
     * 最小
     * @param {*} num 
     */
    checkMultipleMin(num) {
      NProgress.start();
      let $this = this;
      $this.multiple = num;
      if ($this.contentWidth != this.defaultContentWidth) {
        $this.contentWidth = $this.defaultContentWidth;
        this.sliderVal = 50;
        this.sliderOffset(this.sliderVal);
        this.refreshNewResQueryDataAll();
        let sum = ($this.contentWidth - $this.defaultContentWidth) / 2;
        if (sum == 0) {
          this.sliderVisible = 'none';
        }
        this.checkInFlag = 1;
        $this.tackleBaseData($this.dataALL, $this.isoformIndex, () => {
          $this.lollipopDB = genomicsACCUtils.lollipopData($this.gACCData.codingSite, $this.bbdata);
          $this.middleTranslate.middleX = '-' + sum;
          setTimeout(() => {
            $this.initSvg();
            NProgress.done();
          }, 10);
        });
      }
    },
    /**
     * 最大
     * @param {*} num 
     */
    checkMultipleMax(num) {
      NProgress.start();
      let $this = this;
      $this.multiple = num;
      if (this.checkInFlag) {
        $this.contentWidth = $this.defaultContentWidth + genomicsD3Utils.maxWidthScale;
        let sum = ($this.contentWidth - $this.defaultContentWidth) / 2;
        this.sliderVal = 50;
        this.sliderOffset(this.sliderVal);
        this.refreshNewResQueryDataAll();
        if (sum != 0) {
          this.sliderVisible = 'block';
          $this.tackleBaseData($this.dataALL, $this.isoformIndex, () => {
            $this.lollipopDB = genomicsACCUtils.lollipopData($this.gACCData.codingSite, $this.bbdata);
            $this.middleTranslate.middleX = '-' + sum;
            setTimeout(() => {
              $this.initSvg();
              let nodeData = d3.select('.g-codon').data()[0]['nodeData'];
              if (nodeData.checkIn == false) {
                this.checkInFlag = 0;
              }
              NProgress.done();
            }, 10)

          });
        }
      }
    },
    /**
     * 放大
     */
    checkIn() {
      NProgress.start();
      let $this = this;
      $this.multiple = 10;
      if (this.checkInFlag) {
        $this.contentWidth += $this.defaultContentWidth;
        let sum = ($this.contentWidth - $this.defaultContentWidth) / 2;
        this.sliderVal = 50;
        this.sliderOffset(this.sliderVal);
        this.refreshNewResQueryDataAll();
        if (sum != 0) {
          this.sliderVisible = 'block';
          $this.tackleBaseData($this.dataALL, $this.isoformIndex, () => {
            $this.lollipopDB = genomicsACCUtils.lollipopData($this.gACCData.codingSite, $this.bbdata);
            $this.middleTranslate.middleX = '-' + sum;
            $this.initSvg();
            NProgress.done();
            let nodeData = d3.select('.g-codon').data()[0]['nodeData'];
            if (nodeData.checkIn == false) {
              this.checkInFlag = 0;
            }
          });
        }
      }
    },
    /**
     * 缩小
     */
    checkOut() {
      NProgress.start();
      let $this = this;
      $this.multiple = -10;
      if ($this.contentWidth != this.defaultContentWidth) {
        $this.contentWidth -= $this.defaultContentWidth;
        this.sliderVal = 50;
        this.sliderOffset(this.sliderVal);
        this.refreshNewResQueryDataAll();
        let sum = ($this.contentWidth - $this.defaultContentWidth) / 2;
        if (sum == 0) {
          this.sliderVisible = 'none';
        } else if (sum < 0) {
          sum = 0;
          this.contentWidth = $this.defaultContentWidth;
          this.sliderVisible = 'none';
        }
        this.checkInFlag = 1;
        $this.tackleBaseData($this.dataALL, $this.isoformIndex, () => {
          $this.lollipopDB = genomicsACCUtils.lollipopData($this.gACCData.codingSite, $this.bbdata);
          $this.middleTranslate.middleX = '-' + sum;
          $this.initSvg();
          NProgress.done();
        });
      }
    },
    /**
     * 左右拖拽-滑动视图
     * @param {*} value 
     */
    sliderChange(value) {
      this.sliderOffsetX = 0;
      let offsetX = (this.contentWidth - this.defaultContentWidth) / 2;
      let middleY = genomicsD3Utils.transitionMiddleMarginTop(306);
      if (offsetX == 0) {
        this.sliderVal = 50;
      } else {
        this.sliderOffset(value);
        d3.select('.g-middle').attr('transform', 'translate(-' + this.sliderOffsetX + ', ' + middleY + ')');
        d3.select('.g-lollipop-sans').attr('transform', 'translate(-' + this.sliderOffsetX + ', ' + genomicsD3Utils.delayContentHeight + ')');
        d3.selectAll('.genomice-svg-down-main .g-lollipop-sans').attr('transform', 'translate(-' + this.sliderOffsetX + ', 0)');
      }
    },

    /**
     * 计算左右滑动px
     * @param {*} value 
     */
    sliderOffset(value) {
      let offsetX = (this.contentWidth - this.defaultContentWidth) / 2;
      if (value > 50) {
        this.sliderOffsetX = offsetX + offsetX * (value - 50) * 2 / 100;
      } else {
        this.sliderOffsetX = offsetX - offsetX * (50 - value) * 2 / 100;
      }
    },
    refreshNewResQueryDataAll() {
      Object.keys(this.newResQueryDataAll).forEach((key, index) => {
        this.newResQueryDataAll[key].times = new Date().getTime();
      })
    },
    /**
     * go page
     */
    goToGenePage() {
      window.open("https://www.ncbi.nlm.nih.gov/gene/" + this.gACCData.ncbiGeneId + "");
    },
    /**
     * go page
     */
    goToEnsemblPage() {
      window.open("https://grch37.ensembl.org/Homo_sapiens/Gene/Summary?db=core;g=" + this.gACCData.ensemblId + "");
    },
    /**
     * dispaly pdomain
     */
    changePdomain(event, val) {
      if (event) {
        d3.selectAll(".uid_" + val.cdd).style("fill-opacity", 1);
        delete this.hiddenPdomain[val.cdd];
      } else {
        d3.selectAll(".uid_" + val.cdd).style("fill-opacity", 0);
        this.hiddenPdomain[val.cdd] = val;
      }
    },
    /**
     * display disc all
     */
    changeLollipopDisplay(event) {
      this.displayClassesCheck = false;
      d3.select('#genomice-svg-content .g-lp-middle').remove();
      if (event) {
        this.lollipopDB.classes.forEach(item => {
          delete this.displayClasses[item.name];
        });
        this.displayClassesCheck = true;
        let data = this.getSvgData(this.lollipopDB);
        this.refreshSvg(data);
      } else {
        this.lollipopDB.classes.forEach(item => {
          this.displayClasses[item.name] = false;
        });
        this.displayClassesCheck = true;
        let data = this.getSvgData(false);
        this.refreshSvg(data);
      }
    },
    /**
     * classes display disc 
     */
    changeLollipopDislayClasses(name) {
      this.displayClassesCheck = false;
      d3.select('#genomice-svg-content .g-lp-middle').remove();
      if (this.displayClasses.hasOwnProperty(name)) {
        delete this.displayClasses[name];
        this.displayClassesCheck = true;
      } else {
        this.displayClasses[name] = false;
        this.displayClassesCheck = true;
      }
      if (this.lollipopDB.classes.length == Object.keys(this.displayClasses).length) {
        this.lollipopChecked = false;
      } else {
        this.lollipopChecked = true;
      }
      let bbdata = Object.assign({}, this.bbdata);
      let newData = genomicsACCUtils.lollipopData(this.gACCData.codingSite, bbdata, this.displayClasses);
      let newSvgData = this.getSvgData(newData);
      this.refreshSvg(newSvgData);
    },
    /**
     * 组装svg相关数据
     * @param {*} popData 
     */
    getSvgData(popData) {
      let newPopDB = null;
      let middleX = this.middleTranslate.middleX, middleY = this.middleTranslate.middleY;
      let middleOffsetX = 20;
      if (popData === false) {
        newPopDB = popData;
      } else if (popData) {
        newPopDB = popData;
      } else {
        newPopDB = this.lollipopDB;
      }
      genomicsD3Utils.leftX = middleX;
      let lollipopSans = genomicsD3Utils.lollipopSans({ param: newPopDB, callback: this.discClickFun });
      genomicsD3Utils.transitionContentHeight('genomice-svg-content', 360);
      middleY = genomicsD3Utils.transitionMiddleMarginTop(306);
      d3.select('.genomice-isoform-info').transition().duration(2000).delay(100).attr("style", "top:" + middleY + "px;");
      d3.select('.genomice-slider-middle').attr("style", "display:" + this.sliderVisible + ";top:" + (middleY + 40) + "px;");
      let res = [{
        append: "g",
        class: "g-middle-slider",
        transform: "translate(" + middleOffsetX + ", 0)",
        children: [
          {
            append: "g",
            class: "g-middle",
            transform: "translate(" + middleX + ", " + middleY + ")",
            duration: 2000,
            delay: 100,
            children: [
              {
                append: "g",
                class: "g-rectangle",
                transform: "translate(0, 0)",
                onMouseMove: (event, datum) => {
                  let thatData = event.target.__data__;
                  if (thatData.append == "rect") {
                    this.exonTipInfo = genomicsACCUtils.getMoveTipInfo(
                      event,
                      this.gACCData,
                      middleOffsetX,
                      this.sliderOffsetX
                    );
                    this.movePdomainData = genomicsACCUtils.getMovePdomainInfo(
                      this.gACCData.pdomain,
                      this.exonTipInfo.MoveOffsetx,
                      this.hiddenPdomain
                    );
                    d3.select(".genomics-move-menu-tip")
                      .transition()
                      .duration(100)
                      .attr(
                        "style",
                        "left:" +
                        (event.pageX + 20) +
                        "px;top:" +
                        (event.pageY + 10) +
                        "px;display:block;opacity:1;"
                      );
                  }
                },
                onMouseOut: (event, datum) => {
                  d3.select(".genomics-move-menu-tip")
                    .transition()
                    .duration(100)
                    .attr(
                      "style",
                      "left:" +
                      event.pageX +
                      "px;top:" +
                      event.pageY +
                      "px;display:none;opacity:0;"
                    );
                },
                children: [
                  { append: "g", children: genomicsD3Utils.rectanglePdomainsRectData(this.gACCData.pdomain) },
                  ...genomicsD3Utils.rectangleRectData(this.gACCData.codingSite),
                  ...genomicsD3Utils.rectangleLineData(this.gACCData.codingSite),
                  ...genomicsD3Utils.rectangleRackTemp(this.contentWidth),
                ],
              },
              genomicsD3Utils.minorTickData(this.gACCData.minorTick),
              genomicsD3Utils.codonSeqData(this.gACCData, this.contentWidth),
            ],
          },
          lollipopSans,
        ]
      }
      ];
      return res;
    },
    /**
     * init svg dom
     */
    initSvg() {
      let data = this.getSvgData();
      return render("#genomice-svg-content", data);
    },
    /**
     * 刷新svg
     * @param {*} data 
     */
    refreshSvg(data) {
      return render("#genomice-svg-content", data);
    },
    /**
     * 新建蛋白质域
     */
    proteinAdd() {
      this.$refs.refGenomicsProteinAdd.submit();
    },
    /**
     * 更新蛋白质域视图显示
     * @param {*} param 
     */
    proteinUpdate(param) {
      let paramJson = param[0];
      if (paramJson) {
        this.gACCData.pdomain.push(paramJson)
        let pdomain = { pdomains: this.gACCData.pdomain };
        this.gACCData = Object.assign({}, genomicsACCUtils.genelookSite(pdomain, this.gACCData));
        this.initSvg();
      }
    },
    /**
     * 新建蛋白质结构域-弹窗
     */
    clickProteinAdd() {
      this.isVisibleProtein = true;
    },
    /**
     * 棒棒糖圆事件
     * @param {*} data 
     */
    discClickBBDataFun(data) {
      this.posDiscData = data[0].nodeData;
      this.posDiscData.checkeds = data[0].checkeds;
      this.isVisible = true;
    },
    /**
     * 基因相关数据详情-弹窗
     * @param {*} data 
     */
    discClickFun(data) {
      this.posDiscData = data.nodeData;
      this.isVisible = true;
    },
    closeModel() {
      this.isVisible = false;
      this.isVisibleProtein = false;
    },

    /**
     * get init base data 
     */
    getInitBaseData() {
      let $this = this;
      Promise.all([$this.getBaseData(), $this.genelookup(), $this.getPdomain()]).then(res => {
        $this.dataALL = res;
        $this.isoformMapItem = res[1];
        $this.tackleBaseData(res, $this.isoformIndex, () => {
          $this.getInitBBData();
        });
      }).finally(() => {

      });
    },
    /**
     * 处理基础数据
     * @param {*} bdData 
     * @param {*} isoformIndex 
     */
    tackleBaseData(bdData, isoformIndex, callback) {
      let baseDB = bdData[0], lookupDB = bdData[1], lstDB = bdData[2];
      let $this = this;
      let gmlstItem = {};
      // if (isoformIndex == 0) {
      gmlstItem = lookupDB[isoformIndex];
      $this.apiOption1.transcriptId = gmlstItem.isoform;
      $this.searchLableIsoform = gmlstItem.isoform;
      let lstDBItem = $this.findIsoformData(lstDB, gmlstItem.isoform);
      $this.gACCData = genomicsACCUtils.compositeBaseData(gmlstItem, baseDB, lstDBItem, $this.contentWidth);
      if (typeof (callback) === 'function') {
        callback();
      }

      // }
    },
    /**
     * 查找转录本数据信息
     * @param {*} data 
     * @param {*} isoform 
     */
    findIsoformData(data, isoform) {
      let res = {};
      if (data) {
        data.forEach((item, index) => {
          if (item.name == isoform) {
            res = item;
            return;
          }
        })
      }
      return res;
    },
    /**
     * 获取棒棒糖接口数据
     * @param {*} isoformIndex 
     */
    getInitBBData(isoformIndex) {
      let $this = this;
      Promise.all([$this.getBBData()]).then(res => {
        $this.bbdata = res[0];
        $this.lollipopDB = genomicsACCUtils.lollipopData($this.gACCData.codingSite, $this.bbdata);
        $this.initSvg();
      }).finally(() => {

      });
    },

    /**
     * get gene base data
     */
    getBaseData() {
      return new Promise((resolve, reject) => {
        this.$get("/gene/ntseq", this.apiOption).then(
          (res) => {
            resolve(res.data.data.seq);
          }, err => {
            reject(err);
          })
      });
    },
    /**
     * get gene lookup
     */
    genelookup() {
      return new Promise((resolve, reject) => {
        this.$get("/gene/genelookup", this.apiOption).then(
          (res) => {
            resolve(res.data.data.gmlst);
          }, err => {
            reject(err);
          })
      });
    },
    /**
     * get gene pdomain<<蛋白质域信息>>
     */
    getPdomain() {
      return new Promise((resolve, reject) => {
        this.$get("/gene/pdomain", this.apiOption).then(
          (res) => {
            resolve(res.data.data.lst);
          }, err => {
            reject(err);
          })
      });
    },
    /**
     * get gene bbdata<<棒棒糖数据>>
     */
    getBBData() {
      return new Promise((resolve, reject) => {
        this.$get("/gene/bbdata", this.apiOption1).then(
          (res) => {
            resolve(res.data.data);
          }, err => {
            reject(err);
          })
      });
    },

  },
};
</script>

<style lang="scss" scoped>
.genomics-index {
  background-color: #fff;

  .ant-dropdown-link {
    color: #162232;

    .anticon {
      font-size: 12px;
      border-radius: 100%;
      background-color: #4C83FF;
      color: #fff;
      padding: 3px 3px;
      vertical-align: initial;
    }
  }

  .hospital-dropdown-linkOn {
    .anticon {
      transition-duration: 1s;
      transform: rotate(180deg);
      line-height: 10px;
    }
  }
}

.genomice-svg-down-main {
  position: relative;
  border-top: 1px dashed #979797;
  margin-top: 10px;

  .g-s-close {
    position: absolute;
    right: 6px;
    top: 6px;
    line-height: 26px;
    font-size: 26px;
    vertical-align: middle;
    cursor: pointer;
  }
}

.genomice-header {
  border-bottom: 1px solid #f0f2f5;
  padding: 15px 20px;

  .genomice-h-info {
    font-size: 14px;
    color: #162232;
    line-height: 28px;
  }

  .genomice-h-name {
    font-size: 16px;
    font-weight: 600;
    color: #428ef7;
    margin-right: 20px;

    &.genomice-text-underline {
      cursor: pointer;
      text-decoration: underline;
      margin-left: 20px;
      margin-right: 0px;
    }
  }

  .genomice-h-isoform {
    display: inline-block;
  }

  .genomice-hg-num {
    font-size: 12px;
    line-height: 17px;
    padding: 1px 5px;
    background-color: rgba(66, 142, 247, 0.3);
    margin-left: 20px;
  }

  .genomice-h-chr-num {
    float: right;
  }
}

.genomics-move-menu-tip,
.genomics-move-disc-tip {
  display: none;
  position: absolute;
  background-color: white;
  font-family: Arial;
  z-index: 1001;
  padding: 15px;
  box-shadow: rgb(153, 153, 153) 0px 2px 4px 1px;
  left: 151.2px;
  opacity: 0;
  top: 347.2px;
  border-radius: 2px;

  .genomics-move-menu-content,
  .genomice-move-disc-content {
    font-size: 10px;
    font-family: Courier;
    line-height: 18px;

    span {
      opacity: 0.6;
      display: inline-block;
      text-align: right;
      width: 50px;
      padding-right: 7px;

      /deep/ &.genomice-disc-counts {
        font-weight: bold;
        color: '#646464'
      }
    }

    .genomics-pdomain-row {
      margin-bottom: 1px;
    }

    .genomice-move-content-i {
      font-style: inherit;
      color: rgba(0, 0, 0, 0.45);
    }

    .genomics-pdomain-avatar {
      display: inline-block;
      height: 20px;
      width: 5px;
      margin-right: 5px;
      vertical-align: middle;
    }
  }

  .bubble-t-arrow,
  .bubble-t-arrow-inner {
    width: 0;
    height: 0;
    position: absolute;
    border: 8px solid transparent;
  }

  .bubble-t-arrow {
    left: 50%;
    margin-left: -9px;
    bottom: -17px;
    border-bottom: 8px solid #428ef7;
    transform: rotate(180deg);
  }

  .bubble-t-arrow-inner {
    left: -8px;
    bottom: -9px;
    border-bottom: 8px solid #fff;
  }
}

.genomics-move-disc-tip {
  border: 1px solid #428ef7;
  padding: 5px 7px;

  .genomice-move-disc-content {
    span {
      width: auto;
    }
  }
}

.genomice-svg-main {
  border: 1px dashed #979797;
  padding: 15px 10px;
  margin-right: 20px;
  min-height: 500px;

  .genomice-content-conter,
  /deep/ .genomics-bb-down-content {
    width: 100%;
    margin: 0 auto;
    padding: 0 50px 0 150px;
  }

  .genomice-content-conter {
    position: relative;

    /deep/ .ant-slider-handle {
      border-color: #4C83FF;
    }

    .genomice-check-in {
      position: absolute;
      width: 50px;
      top: 30%;
      right: 1px;
      margin-top: -40px;
      line-height: 32px;
      text-align: right;
    }

    .genomice-slider-middle {
      position: absolute;
      left: 150px;
      right: 50px;
      display: none;
    }

    .genomice-min-scribing {
      position: absolute;
      left: 0;
      right: 0;
      height: 6px;

      .genomice-min-scribing-content {
        position: relative;
        width: 70%;
        margin: 0 auto;
        height: 6px;
        background-color: #979797;
        border-radius: 4px;
      }

      .genomice-on-scribing {
        cursor: pointer;
        height: 18px;
        width: 8px;
        background-color: #4C83FF;
        margin-top: -6px;
        margin-left: -4px;
        position: absolute;
        left: 50%;
      }
    }

    .genomice-isoform-info {
      position: absolute;
      bottom: 22px;
      font-family: 'Arial';
      text-align: right;
      line-height: 20px;
      color: black;
      width: 150px;
      left: -7px;

      .genomice-isoform-genename {
        font-size: 14px;
        font-weight: bold;
        cursor: pointer;
      }

      .genomice-isoform-name {
        font-size: 13px;
      }
    }
  }


  .f-check-btn {
    display: inline-block;
    color: #428EF7;
    font-size: 20px;
    text-align: center;
    font-weight: bold;
    cursor: pointer;
    margin-right: 20px;
    background: rgba(255, 255, 255, 0.2);
    box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.16);
    border: 1px solid #F0F2F5;
    padding: 0 6px;
    margin-bottom: 7px;

    &:hover {
      color: #6fa6f1;
      box-shadow: 0px 2px 3px 0px rgba(116, 116, 116, 0.16);
    }

    &.f-check-mbtn {
      font-size: 12px;
    }

    &.on {
      background-color: #4C83FF;
      color: #fff;
    }
  }
}

.amino-box {
  padding: 15px 20px;
}

.amino-clb {
  text-align: left;
  padding-bottom: 30px;

  .fr {
    float: right;
    width: 40px;
  }

  .amino-clb-tit {
    font-size: 12px;
    font-weight: 400;
    color: #9b9b9b;
    line-height: 17px;
  }

  .amino-clb-box {
    padding-bottom: 20px;

    .amino-clb-a {
      font-size: 12px;
      margin-left: 5px;
      text-decoration: underline;
      color: #428EF7;
    }

    /deep/ .ant-list-item-action {
      margin-left: 7px;
    }
  }

  .amino-clb-item {
    font-size: 12px;
    font-weight: 400;
    color: #333333;
    line-height: 26px;

    .amino-clb-check {
      display: inline-block;
      cursor: pointer;
    }

    .a-clb-dot {
      display: inline-block;
      margin-right: 10px;
      width: 8px;
      height: 8px;
      background: #db3f05;
      border: 1px solid #db3f05;
      border-radius: 100%;
    }

    .a-clb-num {
      margin-left: 5px;
    }

    &.empty {
      color: #9b9b9b;

      .a-clb-dot {
        background-color: #fff;
        border: 1px solid #2495ce;
      }
    }
  }

  .item-meta {
    /deep/ .ant-avatar {
      width: 6px;
      border-radius: 1px;
    }

    /deep/ .ant-list-item-meta-avatar {
      margin-right: 10px;
    }

    /deep/ .ant-list-item-meta-title {
      margin-bottom: 2px;
      font-size: 12px;
      line-height: 14px;
    }

    /deep/ .ant-list-item-meta-description {
      font-size: 12px;
      line-height: 18px;
    }

    /deep/ .ant-list-split .ant-list-item {
      border-bottom: 0;
      padding: 6px 0;
    }
  }

  .amino-clb-add {
    margin: 0 15px;
    cursor: pointer;
    height: 30px;
    border: 1px solid #9b9b9b;
    text-align: center;
    line-height: 28px;
    font-size: 12px;
    color: #333333;
    border-radius: 2px;

    &:hover {
      border-color: #1890ff;
      color: #1890ff;
    }
  }
}
</style>